import { useState } from "react";
import { Link } from "react-router-dom";
import { MailCheck } from "lucide-react";
import { AuthLayout, Field, inputCls, primaryBtn } from "@/components/AuthLayout";
import { api, errMsg } from "@/lib/api";

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [sent, setSent] = useState(false);
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    setError("");
    try {
      await api.post("/auth/forgot-password", { email });
      setSent(true);
    } catch (err) {
      setError(errMsg(err));
    } finally {
      setBusy(false);
    }
  };

  return (
    <AuthLayout
      title="Forgot your password?"
      subtitle="Enter the email you use for Comfort Taxi and we'll send you a secure reset link."
      side={{ title: "Back on the road in a minute.", text: "Reset links work once and expire after 1 hour." }}
    >
      {sent ? (
        <div data-testid="forgot-sent-message" className="rounded-2xl border border-blue-100 bg-blue-50 p-5 text-sm text-blue-900">
          <MailCheck className="mb-2 h-6 w-6 text-blue-700" />
          If <strong>{email}</strong> is registered, a reset link is on its way. Check your inbox (and spam folder).
        </div>
      ) : (
        <form onSubmit={submit} className="space-y-5" data-testid="forgot-form">
          <Field label="Email">
            <input data-testid="forgot-email-input" type="email" required className={inputCls} value={email} onChange={(e) => setEmail(e.target.value)} />
          </Field>
          {error && <p data-testid="forgot-error" className="rounded-lg bg-red-50 px-3 py-2 text-sm text-red-700">{error}</p>}
          <button type="submit" data-testid="forgot-submit-button" disabled={busy} className={primaryBtn}>{busy ? "Sending…" : "Send reset link"}</button>
        </form>
      )}
      <p className="mt-8 text-sm text-slate-500">
        Remembered it? <Link to="/login" data-testid="forgot-to-login-link" className="font-semibold text-blue-700">Back to sign in</Link>
      </p>
    </AuthLayout>
  );
}
